import {generate} from 'shortid'

const generateId = function () {
  return generate().replace('_', '-')
}

export {
  generateId
}

export default generate
